<mat-form-field appearance="outline">
	<mat-label>{{ label }}</mat-label>
	@if (!hasInitialFocus()) {
		<input type="text" matInput [formControl]="control" [name]="label"
	       [matAutocomplete]="auto"
	       data-test-id="one-value-autocomplete-input">
	}
	@if (hasInitialFocus()) {
		<input cdkFocusInitial type="text" matInput [formControl]="control" [name]="label"
	       [matAutocomplete]="auto"
	       data-test-id="one-value-autocomplete-input">
	}

	<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
		@for (value of filteredOptions | async; track value) {
			<mat-option [value]="value.value" class="focus-inwards-dark"
		            data-test-id="one-value-autocomplete-option">
			{{ value.label }}
		</mat-option>
		}
	</mat-autocomplete>

</mat-form-field>
